export interface Avatar {
  id: string;
  name: string;
  imagePath: string;
  category: string;
  price?: number;
  type: 'market' | 'achievement' | 'vanguard';
}

export const AVATARS: Avatar[] = [
  // Market Avatars (Gallery Photos)
  { 
    id: 'g1', 
    name: 'Placeholder', 
    imagePath: '/assets/Gallery/focus_intensity.png', 
    category: 'Abstract', 
    price: 1500, 
    type: 'market' 
  },
  { 
    id: 'g2', 
    name: 'Infinite Tiles', 
    imagePath: '/assets/Gallery/the_path.png', 
    category: 'Abstract', 
    price: 2500, 
    type: 'market' 
  },
  { 
    id: 'g3', 
    name: 'Static Void', 
    imagePath: '/assets/Gallery/debris_field.png', 
    category: 'Abstract', 
    price: 1000, 
    type: 'market' 
  },
  { 
    id: 'g4', 
    name: 'BPM Overload', 
    imagePath: '/assets/Gallery/velocity.png', 
    category: 'Abstract', 
    price: 2000, 
    type: 'market' 
  },
  { 
    id: 'g5', 
    name: 'Ruby Fracture', 
    imagePath: '/assets/Gallery/crystalline_heart.png', 
    category: 'Abstract', 
    price: 3000, 
    type: 'market' 
  },
  { 
    id: 'g6', 
    name: 'Market Pulse', 
    imagePath: '/assets/Gallery/digital_vault.png', 
    category: 'Abstract', 
    price: 5000, 
    type: 'market' 
  },
  { 
    id: 'g7', 
    name: 'The Hoshi Cube', 
    imagePath: '/assets/Gallery/the_vip_star.png', 
    category: 'Abstract', 
    price: 10000, 
    type: 'market' 
  },
  { 
    id: 'g8', 
    name: 'Steady Pulse', 
    imagePath: '/assets/Gallery/the_chain.png', 
    category: 'Abstract', 
    price: 1500, 
    type: 'market' 
  },

  // --- Vanguard Mission Evolution Art ---
  // Star Burst (High Score)
  { id: 'hs_starburst_t1', name: 'Star Fold (Bronze)', imagePath: '/assets/Gallery/velocity.png', category: 'Vanguard', type: 'vanguard' },
  { id: 'hs_starburst_t2', name: 'Star Prism (Silver)', imagePath: '/assets/Gallery/crystalline_heart.png', category: 'Vanguard', type: 'vanguard' },
  { id: 'hs_starburst_t3', name: 'Star Core (Gold)', imagePath: '/assets/Gallery/the_vip_star.png', category: 'Vanguard', type: 'vanguard' },
  { id: 'hs_starburst_t4', name: 'Supernova (Diamond)', imagePath: '/assets/Gallery/focus_intensity.png', category: 'Vanguard', type: 'vanguard' },

  // Cloud (Marathon/HS)
  { id: 'hs_cloud_t1', name: 'Vapor Fold', imagePath: '/assets/Gallery/the_path.png', category: 'Vanguard', type: 'vanguard' },
  { id: 'hs_cloud_t2', name: 'Sky Prism', imagePath: '/assets/Gallery/debris_field.png', category: 'Vanguard', type: 'vanguard' },
  { id: 'hs_cloud_t3', name: 'Cloud Core', imagePath: '/assets/Gallery/velocity.png', category: 'Vanguard', type: 'vanguard' },
  { id: 'hs_cloud_t4', name: 'Nebula', imagePath: '/assets/Gallery/focus_intensity.png', category: 'Vanguard', type: 'vanguard' },

  // Gold Rush
  { id: 'hs_gold_t1', name: 'Ingot Fold', imagePath: '/assets/Gallery/digital_vault.png', category: 'Vanguard', type: 'vanguard' },
  { id: 'hs_gold_t2', name: 'Vault Prism', imagePath: '/assets/Gallery/the_chain.png', category: 'Vanguard', type: 'vanguard' },
  { id: 'hs_gold_t3', name: 'Midas Core', imagePath: '/assets/Gallery/the_vip_star.png', category: 'Vanguard', type: 'vanguard' },
  { id: 'hs_gold_t4', name: 'Singularity', imagePath: '/assets/Gallery/focus_intensity.png', category: 'Vanguard', type: 'vanguard' },
];
